import React, { FC } from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonPageHeader, SkeletonPageShell, SkeletonResponsiveGrid, SkeletonStack, SkeletonSurface } from 'src/components/widgets/skeleton';

const ProviderShell = styled(SkeletonPageShell).attrs({ $padding: '20px 0 48px' })``;

const ProviderCardSkeleton = styled(SkeletonSurface).attrs({ $padding: '20px 20px 12px', $radius: '8px', $minHeight: '150px' })`
    border-left-width: 3px;
`;

const ProviderPanelSkeleton = styled(SkeletonSurface).attrs({ $padding: '24px', $radius: '8px' })``;

const ProviderFieldsGridSkeleton = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    min-width: 0;

    @media (max-width: 760px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const ProviderHeaderSkeleton: FC<{ detail?: boolean }> = ({ detail = false }) => (
    <SkeletonPageHeader>
        <SkeletonStack $gap='8px' $flex='1'>
            <SkeletonBlock $width={detail ? 'min(320px, 100%)' : 'min(220px, 100%)'} $height='26px' />
            {!detail && <SkeletonBlock $width='min(720px, 100%)' $height='13px' />}
            {!detail && <SkeletonBlock $width='min(520px, 100%)' $height='13px' />}
        </SkeletonStack>
    </SkeletonPageHeader>
);

export const ProviderConfigurationPageSkeleton: FC = () => (
    <ProviderShell aria-hidden='true'>
        <ProviderHeaderSkeleton />
        <SkeletonResponsiveGrid $columns='repeat(3, minmax(0, 1fr))' $gap='16px' $tabletColumns='repeat(2, minmax(0, 1fr))'>
            {Array.from({ length: 3 }).map((_, index) => (
                <ProviderCardSkeleton key={index}>
                    <SkeletonStack $gap='10px'>
                        <SkeletonBlock $width='112px' $height='24px' />
                        <SkeletonBlock $width='92px' $height='20px' />
                        <SkeletonBlock $width='min(260px, 100%)' $height='13px' />
                        <SkeletonBlock $width='min(220px, 80%)' $height='13px' />
                        <SkeletonBlock $width='18px' $height='18px' $margin='4px 0 0 auto' />
                    </SkeletonStack>
                </ProviderCardSkeleton>
            ))}
        </SkeletonResponsiveGrid>
        <SkeletonBlock $width='min(360px, 100%)' $height='13px' $margin='16px 0 0' />
    </ProviderShell>
);

export const ProviderDetailPageSkeleton: FC = () => (
    <ProviderShell aria-hidden='true'>
        <ProviderHeaderSkeleton detail />
        <ProviderPanelSkeleton>
            <SkeletonStack $gap='20px'>
                <SkeletonBlock $width='160px' $height='20px' />
                <ProviderFieldsGridSkeleton>
                    <SkeletonBlock $height='38px' $radius='6px' />
                    <SkeletonBlock $height='38px' $radius='6px' />
                    <SkeletonBlock $height='38px' $radius='6px' />
                    <SkeletonBlock $height='38px' $radius='6px' />
                </ProviderFieldsGridSkeleton>
                <SkeletonBlock $height='58px' $radius='8px' />
                <SkeletonBlock $width='118px' $height='36px' $radius='6px' />
            </SkeletonStack>
        </ProviderPanelSkeleton>
    </ProviderShell>
);
